export default "__VITE_ASSET__Bglp6j4J__"